import { filter, every, some } from 'lodash'

export default {
  computed: {
    talentAppliedForBooking () {
      return filter(this.booking.talent, talent => talent.response.status === 'applied').length
    },

    talentDeclinedBooking () {
      return filter(this.booking.talent, talent => talent.response.status === 'declined').length
    },

    talentHasAppliedForBooking () {
      if (this.$userIsTalent) {
        return this.bookingCurrentTalent &&
          this.bookingCurrentTalent.response.status === 'applied'
      } else if (this.$userIsManager) {
        return this.booking.talent.length > 0 &&
          every(this.booking.talent, talent => talent.response.status === 'applied')
      }
    },

    talentHasDeclinedBooking () {
      if (this.$userIsTalent) {
        return this.bookingCurrentTalent &&
          this.bookingCurrentTalent.response.status === 'declined'
      } else if (this.$userIsManager) {
        return this.booking.talent.length > 0 &&
          every(this.booking.talent, talent => talent.response.status === 'declined')
      }
    },

    talentHasMixedResponse () {
      if (this.$userIsManager) {
        return this.booking.talent.length > 0 &&
          some(this.booking.talent, talent => talent.response.status === 'declined') &&
          some(this.booking.talent, talent => talent.response.status === 'applied')
      }
    }
  }
}
